import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class TreatmentsService {
  videoCdnUrl = environment.googleCDNUrl;

  constructor(private http: HttpClient) {}

  GetGeneralTreatments() {
    return this.http.get(
      "../assets/Data/GeneralTreatments.json?currenDate=" + new Date()
    );
  }
  GetPreventativeTreatments() {
    return this.http.get(
      "../assets/Data/PreventiveDentistry.json?currenDate=" + new Date()
    );
  }
  GetCosmeticTreatments() {
    return this.http.get(
      "../assets/Data/CosmeticDentistry.json?currenDate=" + new Date()
    );
  } 
  GetFiles() {
    return this.http.get(
      "../assets/images/blogs/ads-bg.png"
    );
  }

  GetMissingTeethTreatments() {
    return this.http.get(
      "../assets/Data/MissingTeeth.json?currenDate=" + new Date()
    );
  }
  GetBracesTreatments() {
    return this.http.get("../assets/Data/Braces.json?currenDate=" + new Date());
  }
  GetBoldBeautifulTreatments() {
    return this.http.get(
      "../assets/Data/BoldBeautiful.json?currenDate=" + new Date()
    );
  }
  GetConsiciousTreatments() {
    return this.http.get(
      "../assets/Data/ConsciousSedation.json?currenDate=" + new Date()
    );
  }
  GetMemberShipPlans() {
    return this.http.get(
      "../assets/Data/MembershipPlan.json?currenDate=" + new Date()
    );
  }
  GetGuidedBioFilmMemberPlans() {
    return this.http.get(
      "../assets/Data/GuidedBioFilmMemberShipPlan.json?currenDate=" + new Date()
    );
  }
  GetTreatmentFees() {
    return this.http.get(
      "../../assets/Data/Fees.json?currenDate=" + new Date()
    );
  }
  GetInterestFreePlansFaqs() {
    return this.http.get(
      "../../assets/Data/InterestFreePlansFaqs.json?currenDate=" + new Date()
    );
  }

  GetTreatmentGllery() {
    return this.http.get(
      "../../assets/Data/TreatmentsGallery.json?currenDate=" + new Date()
    );
  }
}
